export default function assignPerson(basicEntity: any, providerBlob: any) {
    return basicEntity && providerBlob
        ? {
              basicEntity,
              ...{
                  name: providerBlob.name,
                  phone: providerBlob.phone,
              },
          }
        : null;
}
